import React from 'react';
import { Switch, message } from 'antd';
import { useDispatch } from 'react-redux';
import { updateConversationPreferences } from '@/apis/chat';
import { refreshChatSummary } from '@/store/modules/notifications';
import usePrivateAction from '@/utils/usePrivateAction';

const ConversationMute = ({ room, onChange, label = '免打扰', disabled = false }) => {
  const { busy, run } = usePrivateAction(); const dispatch = useDispatch();
  return <label className="conversation-mute">{label} <Switch aria-label="会话免打扰" checked={Boolean(room.is_muted)} loading={busy} disabled={busy || disabled}
    onChange={is_muted => run(() => updateConversationPreferences(room.id, { is_muted }), result => {
      onChange(result); dispatch(refreshChatSummary()).catch(() => {});
      message.success(result.is_muted ? '已开启免打扰，消息仍会保留' : '已恢复会话提醒');
    })} /></label>;
};
export default ConversationMute;
